import { get } from 'lodash/fp';

export const getResultSelection = get('resultSelection');
